import React from 'react'
import LanguageSwitcher from 'Frontend/components/LanguageSwitcher'
import { Layout } from 'antd'
import { useTranslation } from 'react-i18next'
import Images from 'Assets/Images'
import './styles.scss'

const Footer = () => {
  const { t } = useTranslation()
  return (
    <Layout.Footer className='footer-container'>
      <div className='wrapper'>
        <div className='footer-top'>
          <div className='left-side'>
            <img width={45} src={Images.logoYoshimoto} className='logo-footer' />
          </div>
          <div className='middle-side'>
            <img width={40} src={Images.icSmileFace} />
            <span className='text text-color-4 text-size-1x ML7'>©YOSHIMOTO KOGYO</span>
          </div>
          <div className='right-side-top'>
            <LanguageSwitcher />
          </div>
        </div>
        <div className='footer-bottom'>
          <div className='left-side'>
            <span className='text text-size-1x text-color-4'>Copyright <img src={Images.icInfinity} width={18} /> © XCREATION Co., Ltd.</span>
          </div>
          <div className='right-side'>
            <ul className='footer-nav'>
              <a href='https://yoshimotokoreka.com/private-policy' target='_blank'>
                <li className='footer-nav-item'>{t('footer.policy')}</li>
              </a>
              <a href='https://yoshimotokoreka.com/terms-of-service' target='_blank'>
                <li className='footer-nav-item'>{t('footer.terms')}</li>
              </a>
              <a href='https://yoshimotokoreka.com/specified-commercial-transactions' target='_blank'>
                <li className='footer-nav-item'>{t('footer.commercial')}</li>
              </a>
              <a href='https://yoshimotokoreka.com/payment-services-act' target='_blank'>
                <li className='footer-nav-item'>{t('footer.paymentServices')}</li>
              </a>
            </ul>
          </div>
        </div>
      </div>

    </Layout.Footer>
  )
}

export default Footer